import Service from "../../service/index";
import response from "vue-resource/src/http/response";

const getDefaultState = () => {
    return {
        access_token: null,
        token_type: null,
    };
};
const Auth = {
    namespaced: true,
    state: {
        test : "",
        user: [],
        user_login: null,
        form: {
            first_name: "",
            last_name : "",
            sid : "",
            phone_number: "",
            email: "",
        },
        login_form:{
            sid: "",
            phone_number:"",

        },
        access_token: null,
        token_type: null,
        registerToken : null,
        username : ""
    },
    mutations: {
        SET_USER: (state, user) => {
            state.user = user.hospname;
        },
        SET_USER_LOGIN: (state, user) => {
            state.user_login = user;
        },
        SET_TOKEN_REGISTER : (state, token) => {
            state.registerToken = token;
        },
        SET_TOKEN(state, res) {
            state.access_token = res.access_token;
            state.token_type = res.token_type;
            state.username = res.user.hospname;
        },
        CLEAR_FORM_DATA: state => {
            state.form = {
                first_name: "",
                last_name : "",
                sid : "",
                phone_number: "",
                email: "",
            };
        },
        RESET: state => {
            Object.assign(state, getDefaultState());
        },
    },
    actions: {
        login({ commit }, data) {
            return Service.Auth.login(data).then(response =>{
                commit('SET_TOKEN', response);
                console.log(response)
            });

        },
        register({ commit }, data) {
            return Service.Auth.register(data).then(response => {
                console.log(response)
                // commit("SET_TOKEN_REGISTER", response.success.token);
                // commit("SET_USER", response);
                return data;
            });
        },
        logout({ commit }) {
            commit("RESET",'');
        },
        clearFormData({ commit }) {
            commit("CLEAR_FORM_DATA");
        },
        setUser({commit}) {
            return Service.Auth.getUserAll().then(res => {
                commit("SET_USER", res);
            });
        },
        getToken({ commit }, data) {
            return Service.Auth.getToken(data).then(data => {
                commit("SET_TOKEN", data.success.token);
            }).catch(err => Promise.reject(err));
        },
        getTest({commit}, data){
            commit("TEST",data);
        }
    }
};

export default Auth;
